import type { DrawerProps as MUIDrawerProps } from '@mui/material';
import {
  Box,
  Drawer as MUIDrawer,
  IconButton,
  Paper,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import type { CSSProperties, PropsWithChildren } from 'react';

import styles from './styles';

type DrawerProps = Omit<MUIDrawerProps, 'onClose'> & {
  onClose: () => void;
  justifyContent?: CSSProperties['justifyContent'];
  title?: string;
  /** Applied as `width` on the drawer paper (supports breakpoints). */
  paperWidth?: CSSProperties['width'] | Record<string, CSSProperties['width']>;
};

const Drawer = ({
  paperWidth = { xs: '100%', sm: 280 },
  onClose,
  children,
  justifyContent = 'space-between',
  title,
  slotProps,
  ...props
}: PropsWithChildren<DrawerProps>): JSX.Element => {
  return (
    <MUIDrawer
      {...props}
      onClose={onClose}
      slotProps={{
        ...slotProps,
        paper: {
          component: Paper,
          elevation: 4,
          sx: {
            ...styles.drawerPaper,
            width: paperWidth,
          },
        },
      }}
    >
      <Box sx={styles.rootColumn}>
        <Box sx={styles.headerRow}>
          {title ? (
            <Typography
              component="h2"
              variant="subtitle1"
              sx={styles.titleTypography}
            >
              {title}
            </Typography>
          ) : (
            <Box sx={styles.titleSpacer} />
          )}
          <IconButton
            type="button"
            onClick={onClose}
            aria-label="Fechar painel"
            edge="end"
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <Box sx={styles.bodyColumn} style={{ justifyContent }}>
          {children}
        </Box>
      </Box>
    </MUIDrawer>
  );
};

export default Drawer;
